export enum DueForService {
    BASED_ON_HOURS = "BASED_ON_HOURS",
    BASED_ON_KILOMETERS = "BASED_ON_KILOMETERS",
    BASED_ON_LAST_SERVICE_DATE = "BASED_ON_LAST_SERVICE_DATE",
    BASED_ON_MONTH_INTERVAL = "BASED_ON_MONTH_INTERVAL"
}